import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

export type CompleteTaskResponse = components['schemas']['Task'];
export type CompleteTaskPath = NonNullable<paths['/executor_web/tasks/{id}/complete']['patch']['parameters']['path']>;

/** PATCH `/api/executor_web/v1/executor_web/tasks/{id}/complete` — см. `paths['/executor_web/tasks/{id}/complete']` в openapi */
export function completeTask(path: CompleteTaskPath, signal?: AbortSignal) {
	return axiosInstance.patch<CompleteTaskResponse>(`tasks/${path.id}/complete`, undefined, {signal});
}
